import React from 'react';
import { IconProps } from '.';

const SvgBeautyFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M16 12a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h8ZM13.286 1.498C13.956.94 15 1.406 15 2.276V9.5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V4.828c0-.384.22-.734.562-.91.633-.324 1.675-.884 2.438-1.418.387-.27.846-.635 1.286-1.002Z'
      />
    </svg>
  );
};

export default SvgBeautyFillRounded;
